/* GMapControlsBuilder -- builds dropdown controls (gear menu and kml menu) for Google Map */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var ENTER_KEY_CODE = 13;
  const KML_FETCH_INTERVAL = 300000; // in milliseconds
  const MENU_HEIGHT_BUFFER = 120;

  function GMapControls(gMap) {
    this.gMap = gMap;

    // A random value to append to DOM element IDs to prevent name conflicts
    // when multiple maps are loaded on the same page.
    this.uniqueSuffixForDomIds = "" + Math.floor(Math.random() * 1e10);
  }

  GMapControls.prototype.addControlUi = function (mapLayers, options) {
    var controlDiv = document.createElement('div');
    controlDiv.style.cssText = 'z-index: 100';
    if (options.includeMapConfig) {
      $(controlDiv).append(this.addMapConfigControls(options));
    }
    if (mapLayers && mapLayers.length > 0) {
      $(controlDiv).append(this.addKmlControls(mapLayers, options));
    }
    this.gMap.map().controls[google.maps.ControlPosition.TOP_LEFT].push(controlDiv);
  };

  GMapControls.prototype.addMapConfigControls = function (options) {
    var self = this;
    var markerType = self.gMap.getEventMarkerType();

    var suffix = self.uniqueSuffixForDomIds;
    var mapControlDropdownId = "map_control_dropdown" + suffix;
    var mapControlButtonId = "map_control_button" + suffix;
    var mapControlStationDisplayId = "map_control_station_display" + suffix;
    var mapControlEventMarkersAutomaticId = "map_control_event_markers_automatic" + suffix;
    var markerSwitcherName = "event_marker_switcher" + suffix;
    var mapControlEventMarkerSizeMultiplierId = "map_control_event_marker_size_multiplier" + suffix;
    var mapControlUpdateLinkId = "map_control_update_link" + suffix;
    var mapControlResetLinkId = "map_control_reset_link" + suffix;
    var mapControlShakeMapOpacityId = "map_control_shake_map_opacity" + suffix;
    var mapControlShakeMapOpacityValueId = "map_control_shake_map_opacity_value" + suffix;
    var prefix = "map_control_event_markers_";

    var markerTypeControls = [{
      "label": I18n.t("globals.gmap.event_markers.color_by_date_size_by_magnitude"),
      "markerType": self.gMap.MARKER_TYPES.DATE,
      "domId": prefix + "date" + suffix
    }, {
      "label": I18n.t("globals.gmap.event_markers.color_by_depth_size_by_magnitude"),
      "markerType": self.gMap.MARKER_TYPES.DEPTH,
      "domId": prefix + "depth" + suffix
    }, {
      "label": I18n.t("globals.gmap.event_markers.color_by_magnitude_size_fixed"),
      "markerType": self.gMap.MARKER_TYPES.MAGNITUDE,
      "domId": prefix + "magnitude" + suffix
    }, {
      "label": I18n.t("globals.gmap.event_markers.color_by_date_size_fixed"),
      "markerType": self.gMap.MARKER_TYPES.DATE_FIXED,
      "domId": prefix + "date_fixed" + suffix
    }
    ];

    var dropdownHtml = dropdownStart(mapControlDropdownId);

    if (options.includeShowStations) {
      dropdownHtml += dropdownCheckbox(mapControlStationDisplayId, MapCookies.hasShowStationsSelected(), I18n.t("globals.gmap.show_stations_checkbox"));
      dropdownHtml += dropdownDivider();
    }
    if (options.includeEventMarkers) {
      dropdownHtml += dropdownHeader(I18n.t("globals.gmap.event_markers_heading")) +
        dropdownRadioButton(mapControlEventMarkersAutomaticId, markerType.indexOf(self.gMap.MARKER_FLAG_AUTOMATIC) != -1, I18n.t("globals.gmap.event_markers.automatic"), markerSwitcherName);

      $.each(markerTypeControls, function (index, control) {
        dropdownHtml += dropdownRadioButton(control.domId, markerType == control.markerType, control.label, markerSwitcherName);
      });

      var multiplierMin = "10";
      var multiplierMax = "100";
      var multiplierInputData = {
        id: mapControlEventMarkerSizeMultiplierId,
        value: self.gMap.getEventMarkerMultiplier() * 100,
        min: multiplierMin,
        max: multiplierMax,
        step: "1",
        title: I18n.t("globals.gmap.marker_size_multiplier_textbox_tooltip", {
          multiplier_min: multiplierMin,
          multiplier_max: multiplierMax
        }),
        errorMessage: I18n.t("globals.gmap.marker_size_multiplier_textbox_error", {
          multiplier_min: multiplierMin,
          multiplier_max: multiplierMax
        }),
        linkId: mapControlUpdateLinkId
      };
      dropdownHtml += dropdownDivider() + dropdownHeader(I18n.t("globals.gmap.marker_size_multiplier_heading")) +
        dropdownNumberInput(multiplierInputData) + dropdownLink(mapControlResetLinkId, I18n.t("globals.gmap.reset_marker_size_button"));
    }
    if (options.includeShakeMap) {
      dropdownHtml += dropdownHeader(I18n.t('globals.gmap.shake_map_opacity_slider')) +
        dropdownSlider(mapControlShakeMapOpacityId, 0, 1, "any", MapCookies.getShakeMapOpacity(), mapControlShakeMapOpacityValueId, toPercent);
    }
    dropdownHtml += dropdownEnd();

    var controlDiv = document.createElement('div');
    var cssText = 'margin-top: 10px; ' + (options.showMapTypeControl ? 'margin-left: 0; ' : 'margin-left: 10px; ') + 'margin-right: 9px; display: inline-block';
    controlDiv.style.cssText = cssText;
    controlDiv.innerHTML = dropdownButton(mapControlButtonId, mapControlDropdownId, GMapUtil.imageTagGear()) + dropdownHtml;
    controlDiv.index = 1;

    google.maps.event.addListenerOnce(self.gMap.map(), 'idle', function () {
      $('#' + mapControlStationDisplayId, controlDiv).on("click", function () {
        MapCookies.toggleStations();
      });
      $('#' + mapControlShakeMapOpacityId, controlDiv).on("input", function () {
        $('#' + mapControlShakeMapOpacityValueId).html(toPercent($(this).val()));
        MapCookies.setShakeMapOpacity(parseFloat($(this).val()));
      });
      $('#' + mapControlEventMarkersAutomaticId, controlDiv).on("click", function () {
        self.gMap.setEventMarkerType(self.gMap.MARKER_FLAG_AUTOMATIC);
      });
      $.each(markerTypeControls, function (index, control) {
        $('#' + control.domId, controlDiv).on("click", function () {
          self.gMap.setEventMarkerType(control.markerType);
        });
      });
      $('#' + mapControlUpdateLinkId, controlDiv).on("click", function () {
        if (!$('#' + mapControlEventMarkerSizeMultiplierId).hasClass("error")) {
          window.location.reload();
        }
      });
      $('#' + mapControlEventMarkerSizeMultiplierId, controlDiv)
        .on("keypress", function (e) {
          if (e.keyCode == ENTER_KEY_CODE) {
            $('#' + mapControlUpdateLinkId).click();
          }
        })
        .on("input", function () {
          var multiplierAsFraction = $(this).val() / 100;
          try {
            self.gMap.setEventMarkerMultiplier(multiplierAsFraction);
            $(this).removeClass("error");
            $('#error_message_' + mapControlEventMarkerSizeMultiplierId).hide();
          }
          catch (e) {
            $(this).addClass("error");
            $('#error_message_' + mapControlEventMarkerSizeMultiplierId).show();
          }
        });
      $('#' + mapControlResetLinkId, controlDiv).on("click", function () {
        self.gMap.setEventMarkerMultiplier(self.gMap.MARKER_MULTIPLIER_DEFAULT);
        window.location.reload();
      });
    });

    return controlDiv;
  };

  GMapControls.prototype.addKmlControls = function (mapLayers, options) {
    var self = this;
    self.kmlLayers = {};
    self.geoJsonLayers = {};
    self.mapLayersById = {}

    var suffix = self.uniqueSuffixForDomIds;
    var kmlControlDropdownId = "kml_control_dropdown" + suffix;
    var kmlControlButtonId = "kml_control_button" + suffix;
    var kmlControlSelectAllClass = "kml_control_select_all" + suffix;
    var kmlControlLayerClass = "kml_control_layer" + suffix;

    var mapHeight = self.gMap.map().getDiv().offsetHeight;
    var dropdownHtml = dropdownStart(kmlControlDropdownId, mapHeight - MENU_HEIGHT_BUFFER) + dropdownCheckbox("", true, I18n.t("globals.gmap.map_layer_dropdown_all_option"), kmlControlSelectAllClass) + dropdownDivider();

    var countUrls = mapLayers.length;
    for (var i = 0; i < countUrls; i++) {
      var showByDefault = mapLayers[i].showByDefault;
      var storedValue = getLocalStorageItem('map_layer_' + mapLayers[i].id);
      // Determine if the layer should be checked on page load:
      // - If there is a stored value in localStorage, use it (convert to boolean).
      // - If there is no stored value, fall back to the default setting (showByDefault).
      var isSelected = (storedValue !== null) ? (storedValue === 'true') : showByDefault;
      dropdownHtml += dropdownCheckbox("", isSelected, mapLayers[i].name, kmlControlLayerClass, mapLayers[i].id);
      if (mapLayers[i].geoJson && isSelected){
        this.addGeoJsonToMap(mapLayers[i]);
      }
      else {
        self.kmlLayers[mapLayers[i].id] = new google.maps.KmlLayer({
          url: Util.makeAbsolute(mapLayers[i].url),
          map: (isSelected ? self.gMap.map() : null),
          preserveViewport: true,
          clickable: mapLayers[i].isInteractive,
          suppressInfoWindows: !mapLayers[i].isInteractive
        });
      }
      self.mapLayersById[mapLayers[i].id] = mapLayers[i];
    }
    dropdownHtml += dropdownEnd();

    var controlDiv = document.createElement('div');
    var leftMargin = (options.showMapTypeControl || options.includeMapConfig ? 'margin-left: 0; ' : 'margin-left: 10px; ');
    var cssText = 'margin-top: 11px; ' + leftMargin + 'margin-right: 5px; display: inline-block';
    controlDiv.style.cssText = cssText;
    controlDiv.innerHTML = dropdownButton(kmlControlButtonId, kmlControlDropdownId, GMapUtil.imageTagMapLayer(), I18n.t("globals.gmap.map_layer_dropdown_tooltip")) + dropdownHtml;
    controlDiv.index = 2;

    google.maps.event.addListenerOnce(self.gMap.map(), 'idle', function () {
      $('.' + kmlControlSelectAllClass, controlDiv).on("click", function () {
        this.checked ? $('.' + kmlControlLayerClass).not(':checked').click() : $('.' + kmlControlLayerClass + ':checked').click();
      });

      $('.' + kmlControlLayerClass, controlDiv).on("click", function () {
        setLocalStorageItem('map_layer_' + this.value, this.checked); // Store the checkbox state in LocalStorage
        if(self.mapLayersById[this.value].geoJson){
          this.checked ? self.addGeoJsonToMap(self.mapLayersById[this.value]) : self.removeGeoJsonFromMap(this.value);
        }
        else {
          var kmlLayer = self.kmlLayers[this.value];
          this.checked ? kmlLayer.setMap(self.gMap.map()) : kmlLayer.setMap(null);
        }

        updateSelectAllCheckbox(); // Update "All" checkbox based on individual checkboxes
      });

      setTimeout(updateSelectAllCheckbox, 1000); // Initial check to update "All" checkbox state with a delay to ensure all checkboxes are fully rendered
    });

    function updateSelectAllCheckbox() {
      var allChecked = $('.' + kmlControlLayerClass + ':checked').length === $('.' + kmlControlLayerClass).length;
      $('.' + kmlControlSelectAllClass).prop('checked', allChecked);
    }

    return controlDiv;
  };

  GMapControls.prototype.addGeoJsonToMap = function(mapLayer) {
    var self = this;
    self.geoJsonLayers[mapLayer.id] = self.gMap.map().data.addGeoJson(JSON.parse(mapLayer.geoJson))
    self.geoJsonLayers[mapLayer.id].forEach(function(feature) {
      self.gMap.map().data.overrideStyle(feature, {
        clickable: mapLayer.isInteractive,
        zIndex: google.maps.Marker.MAX_ZINDEX - mapLayer.displayOrder,
      })
    });
  };

  GMapControls.prototype.removeGeoJsonFromMap = function(mapLayerId) {
    var self = this;
    self.geoJsonLayers[mapLayerId].forEach(function(feature) {
      self.gMap.map().data.remove(feature);
    });
    delete self.geoJsonLayers[mapLayerId];
  };

  GMapControls.prototype.updateMapLayerUrls = function () {
    const mapLayerListQuery = {
      "query": "{ _mapLayerList_(isDisplayed: true){ mapLayers{ id externalUrl } } }",
    };

    var self = this;
    $.ajaxSetup({
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-CSRF-Token', formAuthenticityToken);
      }
    });
    $.post("/graphql", mapLayerListQuery, function (data) {
      let mapLayersJson = data["data"]["_mapLayerList_"]["mapLayers"];
      mapLayersJson.forEach(function (mapLayer) {
        mapLayer["id"] = parseInt(mapLayer["id"]);
      });

      mapLayersJson.forEach(function (mapLayer) {
        if(mapLayer["id"] in self.kmlLayers){
          self.kmlLayers[mapLayer["id"]].setUrl(mapLayer["externalUrl"]);
        }        
      });
    });
  };

  return function (gMap, mapLayers, options) {
    if (!gMap.map()) {
      throw new Error("gMap must be initialized (setupMap called) before adding controls");
    }
    var gMapControls = new GMapControls(gMap);
    gMapControls.addControlUi(mapLayers, options);
    setInterval(function() { gMapControls.updateMapLayerUrls(); }, KML_FETCH_INTERVAL);

    return gMapControls;
  };

  function dropdownButton(buttonId, dropdownId, imageTag, title) {
    title = title || "";
    return "<div id='" + buttonId + "' class='map_control_button' data-jq-dropdown='#" + dropdownId + "' title='" + title + "'>" + imageTag + "</div>"
  }

  function dropdownStart(id, maxHeight) {
    var styles = "max-height:" + maxHeight + "px !important;overflow:auto"
    return "<div id='" + id + "' class='jq-dropdown jq-dropdown-relative'><ul class='jq-dropdown-menu' style='" + styles + "'>";
  }

  function dropdownEnd() {
    return "</ul></div>";
  }

  function dropdownDivider() {
    return "<li class='jq-dropdown-divider'></li>";
  }

  function dropdownHeader(text) {
    return "<li><span class='dropdown_heading'>" + text + "</span></li>";
  }

  function dropdownRadioButton(id, isChecked, text, name) {
    return "<li><label><input type='radio' name='" + name + "' id='" + id + "' " + (isChecked ? "checked='1'" : "") + " />" + text + "</label></li>";
  }

  function dropdownCheckbox(id, isChecked, text, cssClass, value) {
    cssClass = cssClass || "";
    value = value || "";
    return "<li><label><input type='checkbox' class = '" + cssClass + "' value='" + value + "' id='" + id + "' " + (isChecked ? "checked='1'" : "") + "/>" + text + "</label></li>";
  }

  function dropdownNumberInput(options) {
    return "<li><label><input type='number' class='map_control_input' id='" + options.id + "' value='" + options.value + "' title='" + options.title + "' min='" + options.min + "' " +
      "max='" + options.max + "' step='" + options.step + "'/> <a id='" + options.linkId + "'>" + I18n.t("globals.gmap.update_marker_size_button") + "</a><div id='error_message_" + options.id + "' style='display:none' " +
      "class='map_control_input_error'>" + options.errorMessage + "</div></label></li>";
  }

  function dropdownLink(id, text) {
    return "<li><label><a id='" + id + "'>" + text + "</a></label></li>";
  }

  function dropdownSlider(id, min, max, step, value, valueFieldId, valueFormatter) {
    return "<li><label><input type='range' id='" + id + "' min='" + min + "' max='" + max + "' step='" + step + "' value='" + value +
      "'/><div class='range_value' id='" + valueFieldId + "'>" + valueFormatter(value) + "</div></label></li>";
  }

  function toPercent(value) {
    return I18n.t("globals.gmap.percent_value", {value: (parseFloat(value) * 100).toFixed(0)});
  }

  function getLocalStorageItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('LocalStorage is disabled or not available.');
      return null;
    }
  }

  function setLocalStorageItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
        console.warn('LocalStorage is disabled or not available.');
    }
  }
}));
